<template>
    <div class="jump-cart">
        <van-nav-bar title="代下单" left-arrow fixed class="jump-nav-bar" @click-left="back"/>
        <div class="jump-cart-body">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <van-row class="jump-cart-item"  v-for="item in list">
                    <van-col span="24">
                        <van-cell title="会员名称" :value="item.userName" />
                    </van-col>
                    <van-col span="24">
                        <van-cell title="会员手机号" :value="item.mobile"  />
                    </van-col>

                    <van-col span="16">
                        <van-cell title="操作" type="flex" />
                    </van-col>
                    <van-col span="8">
                        <van-button size="small" plain hairline  type="primary" v-if="item.flag==1" @click="cancelcancelReplaceOrder(item.id)">取消代下单</van-button>
                        <van-button size="small" plain type="primary" v-if="item.flag==0"  @click="bmReplaceOrder(item.id)">代下单</van-button>
                    </van-col>

                </van-row>
            </van-list>
        </div>
    </div>
</template>
<script>
    import {NavBar, Row, Col, List, Cell, CellGroup,Button,Dialog} from "vant";

    export default {
        name: "userhistory",
        components: {
            [Dialog.name]: Dialog,
            [Button.name]: Button,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [List.name]: List
        },
        data() {
            return {
                checkedAll: false,
                list: [],
                loading: false,
                finished: false,
                total: 0,
                page: 1
            };
        }, mounted: function () {
        },
        methods: {
            back() {
                history.back();
            }, onLoad() {
                let that = this
                // 异步更新数据
                that.$api.get(
                    that.jumuc.userCenter.getBusinessMyUser,
                   null,
                    successRes => {
                        let orderlist = successRes.data
                        for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                        that.loading = false;
                            that.finished = true;
                    }
                )

            }, cancelcancelReplaceOrder(id) {
                let that = this
                that.$api.post(
                    that.jumuc.userCenter.cancelcancelReplaceOrder,
                   null,
                    successRes => {
                        Dialog.alert({
                            message: successRes.msg
                        }).then(() => {
                            that.list=[]
                            that.onLoad()
                        });

                    })
            },
            bmReplaceOrder(id){
                let that = this
                that.$api.post(
                    that.jumuc.userCenter.bmReplaceOrder,
                    {"id": id},
                    successRes => {
                        Dialog.alert({
                            message: successRes.msg
                        }).then(() => {
                            that.list=[]
                           that.onLoad()
                        });

                    })
            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    .jump-cart {


        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 90%;
                }
            }

            h4 {
                font-size: 14px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 14px;
                &.item-time {
                    color: @bule-thame;
                    font-size: 16px;
                    text-align: right;
                }
                &.item-price {
                    color: red;
                    font-size: 16px;
                    i {
                        font-size: 18px;
                        float: right;
                        color: #f5a623
                    }
                }
            }
        }
    }
</style>

